import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
gsap.config({nullTargetWarn:false});
export default {

  init() {

    $('br').each(function(e){
      $(this).replaceWith('<span class="br"></span>');
    });

    $(document).on('click', '.video-toggle', function(e){
      e.preventDefault();
      var video  = $(this).attr('data-video'),
          toggle = $('video[data-video="'+video+'"').prop('paused') ? 'play' : 'pause',
          text   = $('video[data-video="'+video+'"').prop('paused') ? 'Pause' : 'Play';
      $(this).find('span').html(text);
      $('video[data-video="'+video+'"').trigger(toggle);
    });

    $('.hamburger').on('click', function() {
      $(this).toggleClass('is-active');
      $('.top-bar').toggleClass('open');
      $('html').toggleClass('overflow');
      $('.underlay').toggleClass('show');
      $('body').toggleClass('rel');
      if ($('.stories-menu a').hasClass('is-open')) {
        $('.mega-menu').removeClass('show');
        $('.stories-menu a').removeClass('is-open');
        $('.left-wrap').removeClass('xlarge-5 large-6 medium-12');
        $('.right-wrap').removeClass('show');
        $('.underlay').removeClass('show');
        $('body').removeClass('locked');
      }
      setTimeout(function() {
        $('.mega-menu').css('height', $(window).height() - 68);
      });

      if ($(this).hasClass('is-active')) {
        $('.mega-menu').removeClass('show');
      }
    });

    // Smooth Scroll

    if (window.location.hash) {
      setTimeout(function() {
        var target = $(window.location.hash);
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 110,
          }, 500);
        }
      }, 500); // Delay to ensure the page is fully loaded
    }
  
    // Smooth Scroll on Click
    $('.smooth, .smooth a').click(function() {
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 110,
          }, 500);
          return false;
        }
      }
    });

    let pstl = gsap.timeline({
      scrollTrigger: {
        trigger: '.animation-block',
        start: 'top top',
        scrub: true,
        pin: true,
        pinSpacing: true,
      },
    });
    pstl.to('.icon', { scale: 3, opacity: 0, duration: 1.5 })
    .to('.icon-cover', { scale: 3, duration: 1.5 }, '-=1.5')
    .to('.text', { scale: 0.3, opacity: 1, rotate: 360, duration: 1.5 }, '-=1.5')

    let lines = gsap.utils.toArray('.animated-line');
    lines.forEach((line, i) => {
      let ltl = gsap.timeline({
        scrollTrigger: {
          trigger: line,
          start: 'top center',
          scrub: true,
        },
      })
      ltl.to(line, {height: 400, opacity: 1, duration: 2, ease: 'power4.out'})
    });

    // Slick Slider
    $('.story-slider-container').slick({
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: $('.s-arrow-left'),
      nextArrow: $('.s-arrow-right'),
    });

    $('.hero-slider').slick({
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      infinite: false,
      autoplay: false,
      prevArrow: $('.fw-left'),
      nextArrow: $('.fw-right'),
    });

    // Stop Youtube videos from playing when modal is closed

    $('[data-reveal]').on('closed.zf.reveal', function () {
      let videoIframeSrc = $(this).find('iframe').attr('src');
      console.log(videoIframeSrc);
      $(this).find($('.responsive-embed')).children('iframe').attr('src', '');
      setTimeout(() => {
        $(this).find($('.responsive-embed')).children('iframe').attr('src', videoIframeSrc);
      }, 100)
    });

    $('.stories-menu a').on('click', function(event) {
      event.preventDefault();
      if ($(this).hasClass('is-open')) {
        $('.mega-menu').removeClass('show');
        $('.mega-menu').removeClass('expanded');
        $(this).removeClass('is-open');
        $('.left-wrap').removeClass('xlarge-5 large-6 medium-12');
        $('.right-wrap').removeClass('show');
        $('.underlay').removeClass('show');
        $('body').removeClass('locked');
        $('.nav-filters').addClass('active');
        $('.menu-results').html('');
      } else {
        $('.mega-menu').addClass('show');
        $(this).addClass('is-open');
        $('.underlay').addClass('show');
        $('body').addClass('locked');
      }
    });

    $('.underlay, .close-mm').on('click', function() {
      $('.mega-menu').removeClass('show');
      $('.stories-menu a').removeClass('is-open');
      $('.left-wrap').removeClass('xlarge-5 large-6 medium-12');
      $('.right-wrap').removeClass('show');
      $('.underlay').removeClass('show');
      $('body').removeClass('locked');
      $('.mega-menu').removeClass('expanded');
      $('.nav-filters').addClass('active');
      $('.menu-results').html('');
    });

    $('.menu-results').on('click', '.mob-go-back', function(event) {
      $('.right-wrap').removeClass('show');
      $('.nav-filters').addClass('active');
      $('.menu-results').html('');
      event.preventDefault();
    });

    $('.nav-filters').on( 'click', function(event) {
      $(this).addClass('active');
      $(this).parent().siblings().children().removeClass('active');
      event.preventDefault();

      let data = {
       action: 'load_attorneys',
       termType: $(this).data('type'),
       termLoc: $(this).data('location'),
       name: $(this).data('name'),
       tid: $(this).data('id'),
     }

     $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: data,
      success: function(res) {
        // if ($('.menu-results').hasClass('show')) {
        //   $('.menu-results').html(res);
        // } else {
          // if (res) {
            $('.mega-menu').addClass('expanded');
            $('.left-wrap').addClass('xlarge-5 large-6 medium-12');
            $('.right-wrap').addClass('show');
            setTimeout(() => {
              $('.menu-results').html(res);
            }, 500)
          // }
        // }
      },
    })
   })

    // Handle auto filtering from CTA clicks in main Marquee

    let set
    let searchParams = new URLSearchParams(window.location.search)
    let filter = searchParams.get('filter')
    console.log(filter)
    if (filter && !set) {
      $('.filter-button').removeClass('active');
      $('.filter-button[data-term="'+filter+'"]').trigger('click').addClass('active')
      set = true
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js